<template>
  <div class="create-acivity">
    <div class="acivity-left">
      <img src="../../assets/images/x.png" class="mobile-img">
      <img src="../../assets/images/liuhai.png" class="liuhai" alt="">
      <el-carousel class="scrol-image">
        <el-carousel-item v-for="item in imageArray" :key="item">
          <img :src="item" class="home-pic">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="acivity-right">
      <div style="width: 100%; height: 100%;">
        <div class="tab-tit">
          <a @click="curId = 0" :class="{'cur' : curId === 0}" style="border-radius: 5px 0 0 5px; border-right: 0px;">基础设置</a>
          <a @click="curId = 1" :class="{'cur' : curId === 1}" style="border-right: 0px;">活动配置</a>
          <a @click="curId = 2" :class="{'cur' : curId === 2}" style="border-right: 0px;">奖品设置</a>
          <a @click="curId = 3" :class="{'cur' : curId === 3}" style="border-radius: 0 5px 5px 0">发奖策略</a>
        </div>
        <div v-if="curId === 0">
          <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="100px">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="formInline.name" placeholder="请输入活动名称（不能超过50字）" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item prop="date" label="活动时间">
              <el-date-picker
                v-model="date"
                @change="dateChange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动封面" prop="cover_img">
              <el-upload
                class="avatar-uploader"
                name="file_upload"
                :action="uploadURL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="formInline.cover_img" :src="formInline.cover_img" class="avatar-pic ">
                <img v-else src="../../assets/images/prize-start.png" class="avatar-pic">
              </el-upload>
            </el-form-item>
            <p style="margin-left: 110px; margin-top: -30px;margin-bottom: 5px;text-align: center">请选择1M以下，支持上传jpg/png文件</p>
            <el-form-item label="活动说明" prop="description">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.description">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: center;width: 260px;margin: 0 auto;height: 36px">
            <el-button class="dialog-confirm-btn" type="primary" style="float: left;" @click="curId = 1">下一步</el-button>
          </div>
        </div>
        <div v-if="curId === 1">
          <el-form ref="formInline" :rules="rules" :model="formInline" :inline="true" class="acivity-setting-form" label-width="110px">
            <el-form-item label="抽奖次数上限">
              <el-input-number v-model="formInline.draw_num" controls-position="right" @change="inputNumberChange" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="每日抽奖上限">
              <el-input-number v-model="formInline.everyday_draw_num" controls-position="right"  :min="1" ></el-input-number>
            </el-form-item>
            <el-form-item label="中奖个数上限">
              <el-input-number v-model="formInline.winning_prize_num" controls-position="right" :min="1" ></el-input-number>
            </el-form-item>
            <el-form-item label="每日助力抽奖上限">
              <el-input-number v-model="formInline.assistance_prize_num" controls-position="right" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="活动方式">
              <el-radio-group v-model="formInline.receive_way">
                <el-radio :label="2">线下活动</el-radio>
                <el-radio :label="1">线上活动</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否微信分享">
              <el-radio-group v-model="formInline.wechat_share">
                <el-radio :label="1">允许分享</el-radio>
                <el-radio :label="0">禁止分享</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品数量显示">
              <el-radio-group v-model="formInline.show_num">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关联公众号" prop="public_id" class="public">
              <el-select v-model="formInline.public_id" placeholder="请选择">
                <el-option
                  v-for="item in publicOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择客户来源" prop="source_id" class="public">
              <el-select filterable v-model="formInline.source_id" placeholder="请选择">
                <el-option
                  v-for="item in sources"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源说明" prop="source_content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.source_content">
              </el-input>
            </el-form-item>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" type="primary" @click="curId = 2" style="margin-right: 85px;margin-left: 10px">下一步</el-button>
              <el-button class="dialog-cancel-btn" @click="curId = 0" style="margin-left: 55px">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 2">
          <el-form :inline="false" class="acivity-prize-form">
            <div class="new-add-setting">
              奖品设置至少1个，至多6个
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addPrizeAction">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table
                :data="formInline.prize"
                border
                class="table">
                <el-table-column
                  label="奖品等级"
                  width="90">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品类型"
                  width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                      <el-option
                        v-for="item in prizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品内容"
                  width="220">
                  <template slot-scope="scope">
                    <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                      </el-input-number>
                      <span class="money-span">至</span>
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                      </el-input-number>
                    </div>
                    <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品编号"
                  width="">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 2">无需填写</span>
                    <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="中奖概率"
                  width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.probability" class="prize-percent" placeholder="">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="start"
                  label="奖品数量"
                  width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteRow(scope.$index, formInline.prize)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new-add-setting">
              <el-switch
                :active-value="1"
                :inactive-value="2"
                v-model="formInline.assistance_status"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
              开启助力活动
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addAssistancePrizeAction">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table
                :data="formInline.assistance_prize"
                border
                class="table">
                <el-table-column
                  label="奖品等级"
                  width="90">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品类型"
                  width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                      <el-option
                        v-for="item in prizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品内容"
                  width="220">
                  <template slot-scope="scope">
                    <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                      </el-input-number>
                      <span class="money-span">至</span>
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                      </el-input-number>
                    </div>
                    <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品编号"
                  width="">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 2">无需填写</span>
                    <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="中奖概率"
                  width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.probability" class="prize-percent" placeholder="">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="start"
                  label="奖品数量"
                  width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteRow(scope.$index, formInline.prize)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tip-view">
                注：所有奖项中奖概率和为10%时，则存在不中奖的概率为90%助力活动抽奖次数不计入策略次数中
              </div>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-cancel-btn" style="margin-right: 10px;" @click="curId = 1">上一步</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="curId = 3">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 3">
          <el-form :inline="false" class="acivity-prize-form">
            <div class="new-add-setting">
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addStrategyActivityAction">+ 添加策略</el-button>
            </div>
            <div class="new-add-table">
              <el-table
                :data="formInline.strategy"
                border
                class="table">
                <el-table-column
                  label="奖项"
                  width="90">
                  <template slot-scope="scope">
                    <span>{{level[scope.row.prize_level - 1]}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖项内容"
                  width="90">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prize_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖励策略"
                  width="150">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.cycle_type === 'day'">每天第</span>
                      <span v-if="scope.row.cycle_type === 'week'">每周第</span>
                      <span v-if="scope.row.cycle_type === 'month'">每月第</span>
                      <span v-if="scope.row.cycle_type === 'custom'">{{ scope.row.cycle_start }}-{{ scope.row.cycle_end }}</span>
                      <span v-if="scope.row.cycle_type === 'day' || scope.row.cycle_type === 'week' || scope.row.cycle_type === 'month'">{{ scope.row.specified_times }}次</span>获得该奖励
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="180">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status === 1">启用</div>
                    <div v-if="scope.row.status === 2">停用</div>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="启用" placement="bottom" v-if="scope.row.status === 2">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="startOrStop(scope.row)">启用</i>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="停用" placement="bottom" v-if="scope.row.status === 1">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="startOrStop(scope.row)">停用</i>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="editRow(scope.row)">编辑</i>
                      </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tip-view">
                注：符合其中一项规则即可，多项条件均符合时只中一次
              </div>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addActivityAction()">保存</el-button>
                <el-button class="dialog-cancel-btn" @click="curId = 2">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog class="cellDialog base-dialog" title="指定次数发奖" :visible.sync="addActivityDialog" width="550px">
      <el-form ref="addForm" :rules="addFormRule" :model="addForm">
        <el-form-item label="选择奖项:" label-width="90px" prop="prize_level">
          <el-select v-model="addForm.prize_level" placeholder="请选择">
            <el-option
              v-for="item in formInline.prize"
              :key="item.prize_level"
              :label="item.level"
              :value="item.prize_level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择周期:" label-width="90px" prop="cycle_type">
          <el-select v-model="addForm.cycle_type" placeholder="请选择">
            <el-option
              v-for="item in lotteryPeriod"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间段:" label-width="90px" v-if="addForm.cycle_type === 'custom'">
          <el-date-picker
            v-model="date"
            @change="strategyDateChange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="奖励时机:" label-width="90px" prop="specified_times">
          <div style="display: flex;justify-content: flex-start; flex-direction: row">
            <el-input type="number" v-model="addForm.specified_times" :min="1" placeholder="请输入数字"></el-input>
          <el-tooltip class="item" effect="dark" content="第几次参与该活动可获得指定奖励" placement="right">
            <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
          </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="addActivityDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="submitAddForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog class="cellDialog base-dialog" title="指定次数发奖" :visible.sync="editActivityDialog" width="550px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="选择奖项:" label-width="90px">
          <el-select v-model="editForm.prize_level" placeholder="请选择">
            <el-option
              v-for="item in formInline.prize"
              :key="item.prize_level"
              :label="item.level"
              :value="item.prize_level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择周期:" label-width="90px">
          <el-select v-model="editForm.cycle_type" placeholder="请选择">
            <el-option
              v-for="item in lotteryPeriod"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间段:" label-width="90px" v-if="editForm.cycle_type === 'custom'">
          <el-date-picker
            v-model="date"
            @change="editStrategyDateChange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="奖励时机:" label-width="90px">
          <div style="display: flex;justify-content: flex-start; flex-direction: row">
            <el-input type="number" v-model="editForm.specified_times" :min="1" placeholder="请输入数字"></el-input>
          <el-tooltip class="item" effect="dark" content="第几次参与该活动可获得指定奖励" placement="right">
            <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
          </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editActivityDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { createTreasureBoxActivity, getWechatPublicListForNode, getCustomerSourceListForWepage, getTreasureBoxDetail, editTreasureBox } from '@/api/customer.js'
export default {
  name: 'add-new-year-activity',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value) {
        return callback(new Error(''))
      }
    }
    return {
      editActivityDialog: false,
      editForm: {},
      addForm: {
        cycle_type: '',
        prize_level: '',
        specified_times: ''
      },
      addActivityDialog: false,
      curId: 0,
      tempArray: [require('../../assets/images/home-prize-0.png'), require('../../assets/images/home-prize-1.png'), require('../../assets/images/home-prize-2.png'), require('../../assets/images/home-prize-3.png'), require('../../assets/images/home-prize-4.png'), require('../../assets/images/home-prize-5.png')],
      tempArray1: [require('../../assets/images/home-prize-6.png'), require('../../assets/images/home-prize-7.png')],
      imageArray: [],
      date: [],
      sources: [],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      formInline: {
        name: '',
        start_time: '',
        source_content: '',
        end_time: '',
        draw_num: 1,
        everyday_draw_num: 1,
        winning_prize_num: 1,
        assistance_prize_num: 1,
        set_up: 1,
        receive_way: 1,
        lottery_num: 1,
        source_id: '',
        wechat_share: 1,
        public_id: '',
        cover_img: '',
        description: '',
        show_num: 0,
        strategy: [],
        assistance_prize: [
          {
            prize_level: 1,
            prize_type: 1,
            prize_name: '',
            prize_number: '',
            prize_num: '',
            probability: ''
          }
        ],
        prize: [
          {
            prize_level: '',
            prize_type: 1,
            prize_name: '',
            prize_number: '',
            prize_num: '',
            probability: ''
          }
        ]
      },
      publicOptions: [],
      num8: 1,
      tableData: [
        {
          index: '1'
        }
      ],
      prizeOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '红包'
        }
      ],
      addFormRule: {
        prize_level: [
          { required: true, message: '请选择奖项', trigger: 'blur' }
        ],
        cycle_type: [
          { required: true, message: '请选择周期', trigger: 'blur' }
        ],
        specified_times: [
          { required: true, message: '请输入奖励时机', trigger: 'blur' }
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        source_content: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ],
        cover_img: [
          { required: true, message: '请输上传活动封面图', trigger: 'blur' }
        ]
      },
      everydayNumMax: 1,
      lotteryNumMax: 1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      lotteryPeriod: [
        {
          value: 'day',
          label: '每天'
        }
      ]
    }
  },
  methods: {
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    startOrStop(item) {
      if (item.status === 1) {
        item.status = 2
        _g.toastMsg('success', '停用成功')
      } else {
        item.status = 1
        _g.toastMsg('success', '启用成功')
      }
    },
    editRow(item) {
      this.editActivityDialog = true
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        }
      }
      this.editForm = item
    },
    addStrategyActivityAction() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.addActivityDialog = true
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.addActivityDialog = true
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    // 编辑策略
    confirmEdit() {
      this.editActivityDialog = false
      this.editForm = {}
    },
    // 添加策略
    confirmAdd() {
      console.log('this.addForm.prize_level', this.addForm.prize_level)
      this.addActivityDialog = false
      for (let item of this.formInline.prize) {
        if (item.prize_level === this.addForm.prize_level) {
          this.addForm.prize_name = item.prize_name
        }
      }
      this.formInline.strategy.push({
        prize_level: this.addForm.prize_level,
        prize_name: this.addForm.prize_name,
        cycle_type: this.addForm.cycle_type,
        cycle_start: this.addForm.start_time,
        cycle_end: this.addForm.end_time,
        specified_times: this.addForm.specified_times,
        status: 1
      })
      this.addForm = {}
    },
    // 删除策略
    deleteStrategyRow(item) {
      let index = this.formInline.strategy.indexOf(item)
      this.formInline.strategy.splice(index, 1)
    },
    inputNumberChange(value) {
      this.everydayNumMax = this.formInline.draw_num
      this.lotteryNumMax = this.formInline.draw_num
    },
    deleteRow(index, rows) {
      if (this.formInline.prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    addActivityAction() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        this.formInline.prize[i].prize_level = i + 1
      }
      if (this.formInline.assistance_prize) {
        for (var j = 0; j < this.formInline.assistance_prize.length; j++) {
          this.formInline.assistance_prize[j].prize_level = j + 1
        }
      }
      this.activityId = this.$route.query.id
      editTreasureBox(this.activityId, this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/new-year-activity')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange() {
      this.formInline.start_time = this.date[0]
      this.formInline.end_time = this.date[1]
    },
    strategyDateChange() {
      this.addForm.start_time = this.date[0]
      this.addForm.end_time = this.date[1]
    },
    addPrizeAction() {
      if (this.formInline.prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: '',
        probability: ''
      })
    },
    addAssistancePrizeAction() {
      if (this.formInline.assistance_prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.assistance_prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: '',
        probability: ''
      })
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.cover_img = res.data.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.publicOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 获取客户来源
    getSourceList() {
      getCustomerSourceListForWepage(1).then((res) => {
        if (res.data.code === 0) {
          this.sources = res.data.data.list
        }
      })
    },
    getData() {
      this.activityId = this.$route.query.id
      getTreasureBoxDetail(this.activityId).then(res => {
        this.formInline = JSON.parse(JSON.stringify(res.data.data))
        this.formInline.prize = []
        this.formInline.assistance_prize = []
        for (let item of res.data.data.prize) {
          if (item.type === 1) {
            this.formInline.prize.push(item)
          } else {
            this.formInline.assistance_prize.push(item)
          }
        }
        this.date = [this.formInline.start_time, this.formInline.end_time]
      })
    }
  },
  components: {
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getPublicList()
    this.getSourceList()
    this.getData()
    this.imageArray = this.tempArray
  }
}
</script>

<style scoped>
.create-acivity {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-left {
  width: 40%;
  height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
}
.acivity-right {
  width: 57%;
  height: 800px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: -30px;
}
.mobile-img {
  position: absolute;
}
.scrol-image {
  /*margin-left: 130px;*/
}
.liuhai{
  position: absolute;
  top: 113px;
  z-index: 100;
}
.scrol-image, .scrol-image .el-carousel__item  {
  height: 575px;
  width: 266px;
  border-radius: 26px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.tab-tit {
  width: 534px;
  margin: 90px auto 0;
  margin-bottom: 20px;
  overflow: hidden;
}
.tab-tit .cur {
  background: #1890FF;
  color: #fff;
}

.tab-tit .line, .saveData .line{
  width:90%;
  margin: 2% auto;
  border:0.5px dashed #d2d2d2;
}
.tab-tit a {
  cursor: pointer;
  display:block;
  float: left;
  width: 130px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  color: #333;
  border: 1px solid #1890FF;
}
.acivity-content-form {
  width: 460px;
  text-align: left;
  margin: auto;
}
.acivity-setting-form {
  width: 460px;
  text-align: center;
  margin: auto;
}
.acivity-prize-form {
  /*text-align: center;*/
  /*margin: 0 auto;*/
  width: 100%;
}
.acivity-content-form .el-form-item__content {
  width: 300px;
}
.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.prize-count {
  width: 100px;
}
.prize-count-special{
  width: 90px;
}
.prize-percent {
  width: 80px;
}
.prize-percent .el-input {
  width: 60px;
}
.prize-percent .el-input__inner {
  width: 60px;
  height: 36px;
}
.home-pic {
  width: 100%;
  height: 100%;
}
.avatar-pic {
  height:110px;
  width: 327px;
  display: block;
}
.button-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 20px;
}
.new-add-setting {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: left;
  margin-left: 30px;
  margin-top: 30px;
}
.new-add-table {
  width: 100%;
  margin-top: 10px;
}
.tags-text-item {
  width: 200px;
}
.tip-view {
  margin-left: 20px;
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  color: #666;
}
.money-span {
  display: block;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
}
@media screen and (min-width: 1600px) {
  .acivity-left {
    width: 35%;
    justify-content: flex-end;
    margin-right: 100px;
  }
  .mobile-img{
    right: -23px;
  }
  .liuhai{
    right: 60px;
  }
}
</style>
